import {v2serviceInstance} from './apiVersionInstances';
import {DEFAULT_PAGE_SIZE} from '../constants';

const searchv2API = {
    get(lat, lng, start, end) {
        return v2serviceInstance().get(
            `/search/transient?oversize=false&page_size=${DEFAULT_PAGE_SIZE}&sort_by=relevance&include_walking_distance=true&show_unavailable=false&lat=${lat}&lon=${lng}&starts=${start}&ends=${end}`
        );
    },
};

export default searchv2API;
